import React, { useState } from "react";
import Debuginput from "./Debuginput";
import { useToasts } from "react-toast-notifications";
import Debugoutput from "./Debugoutput";
const Heading = () => {
  const { addToast } = useToasts();
  let details = {
    direction: 120,
    height: 8,
    hw: 5,
    width: 6,
    widthspl: 8,
    startrd: 0,
    endrd: 80,
    radiusofcrown: 3,
    dir: 70,
    rd: 45,
    amt: 50,
    iscrown: false,
    heightfrom: "leftspl",
    pointheight: 2,
  };
  const [dimensions, setDimensions] = useState(details);
  const [isOutput, setIsOutput] = useState(false);
  const [isDebug, setDebug] = useState(false);
  const updateDimension = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    console.log(name, value);
    if (name === "direction" && (e.target.value < 0 || e.target.value > 359)) {
      addToast("Oops! Please choose the input value between 0 and 359", {
        appearance: "error",
      });

      return false;
    }
    if (name === "width" && (e.target.value < 0 || e.target.value > 25)) {
      addToast("Oops! Please choose the input value between 2 and 25", {
        appearance: "error",
      });

      return false;
    }
    if (name === "widthspl" && (e.target.value < 0 || e.target.value > 25)) {
      addToast("Oops! Please choose the input value between 2 and 25", {
        appearance: "error",
      });

      return false;
    }
    if (name === "height" && (e.target.value < 0 || e.target.value > 40)) {
      addToast("Oops! Please choose the input value between 3 and 40", {
        appearance: "error",
      });
      return false;
    }
    if (name === "hw" && (e.target.value < 0 || e.target.value > 25)) {
      addToast("Oops! Please choose the input value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (name === "startrd" && (e.target.value < 0 || e.target.value > 50000)) {
      addToast("Oops! Please choose the input value between 0 and 50000", {
        appearance: "error",
      });
      return false;
    }
    let newdim = { ...dimensions };
    newdim[name] = value;
    setDimensions(newdim);
  };
  const showOutput = () => {
    if (dimensions.width < 2) {
      addToast("Oops! Please choose the Tunnel Width value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (dimensions.widthspl < 2) {
      addToast("Oops! Please choose the Width at Spl value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (dimensions.height < 3) {
      addToast("Oops! Please choose the Tunnel Height value between 3 and 40", {
        appearance: "error",
      });
      return false;
    }
    if (dimensions.hw < 2) {
      addToast(
        "Oops! Please choose the Tunnel Wall Height  value between 2 and 25",
        {
          appearance: "error",
        }
      );
      return false;
    }
    setIsOutput(true);
    setDebug(false);
  };
  const showInput = () => {
    setIsOutput(false);
    setDebug(false);
  };
  return !isOutput ? (
    <Debuginput
      label="Create "
      dimensions={dimensions}
      updatedimension={updateDimension}
      showoutput={showOutput}
    />
  ) : (
    <Debugoutput
      showinput={showInput}
      showdebug={isDebug}
      setshowdebug={setDebug}
      dimensions={dimensions}
    />
  );
};

export default Heading;
